import React from 'react';
import PropTypes from 'prop-types';
import { fieldsType, entityType } from 'types';
import { FieldArray } from 'redux-form';

import IfEmpty from 'components/IfEmpty';

import EntityFieldArray from './components/EntityFieldArray';

import './style.scss';

const ConditionFieldArray = props => {
  const {
    fields,
    isLoadingAllEntities,
    allEntities,
    getAllEntities,
    selectItem,
    onDelete,
    onAddFeature,
    onDeleteFeature,
    onChangeFeatureValues,
  } = props;
  return (
    <IfEmpty message="You need at least one Entity to build a Constraint Set">
      {fields.map((field, index) => (
        <div styleName="condition" key={field}>
          <FieldArray
            name={`${field}.entity.${fields.get(index).entity}`}
            component={EntityFieldArray}
            item={fields.get(index)}
            index={index}
            entityFieldName={field}
            operator={`${field}.operator`}
            isLoadingAllEntities={isLoadingAllEntities}
            allEntities={allEntities}
            getAllEntities={getAllEntities}
            selectItem={selectItem}
            onDelete={onDelete}
            onDeleteFeature={onDeleteFeature}
            onAddFeature={onAddFeature}
            onChangeFeatureValues={onChangeFeatureValues}
          />
        </div>
      ))}
    </IfEmpty>
  );
};

ConditionFieldArray.propTypes = {
  allEntities: PropTypes.arrayOf(entityType),
  isLoadingAllEntities: PropTypes.bool,
  getAllEntities: PropTypes.func,
  onAddFeature: PropTypes.func,
  selectItem: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteFeature: PropTypes.func,
  onChangeFeatureValues: PropTypes.func,

  // redux-form
  fields: fieldsType.isRequired,
};

export default ConditionFieldArray;
